import Loader from './Loader.vue';

const loaderStore = {
state: {
    loading: false,
    requestsPending: 0,
}, 
  settings: {},
  
  setOptions(options) {
    this.settings = Object.assign(this.settings, options);
  },
  setLoader(value) {
    if (typeof value === 'boolean' || notification instanceof Boolean) {
      this.state.loading = value;
    }
  },
  addRequest() {
    if (this.state.requestsPending === 0) {
        this.setLoader(true)
    }
    this.state.requestsPending++;
  },
  completeRequest() {
      if (this.state.requestsPending >= 1) {
          this.state.requestsPending--;
      }

      if (this.state.requestsPending <= 0) {
          this.setLoader(false)
      }
  },
  checkoutPendingCount() {
    return this.state.requestsPending;
  },
  cancelRequests() {
        this.state.requestsPending = 0;
        this.setLoader(false);
  }
};

const loaderPlugin = {
  install(Vue, options) {
    let app = new Vue({
      data: {
        loaderStore: loaderStore
      },
      methods: {
        addRequest() {
          this.loaderStore.addRequest();
        },
        complete() {
          this.loaderStore.completeRequest();
        },
        cancelAll() {
          this.loaderStore.cancelRequests();
        },
      }
    });
    
    Vue.$loader = { addRequest: app.addRequest,  complete: app.complete, cancelAll: app.cancelAll}
    Vue.prototype.$loader = { addRequest: app.addRequest,  complete: app.complete, cancelAll: app.cancelAll}
    Vue.prototype.$loaderApp = app.loaderStore;
    Vue.component('loader', Loader);
    
    if (options) {
      loaderStore.setOptions(options);
    }
  }
};

export default loaderPlugin;
